import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../api";
import { saveAs } from "file-saver";

const EsicPfdataTable = () => {
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchYears();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      fetchMonths(selectedYear);
    }
  }, [selectedYear]);

  const fetchYears = async () => {
    try {
      const response = await api.post("/emp-pay-slip-year-list");
      setYears(response.data.data || []);
      setError(null);
    } catch (err) {
      setError("Failed to fetch years. Please try again later.");
    }
  };

  const fetchMonths = async (year) => {
    try {
        const response = await api.post("/emp-pay-slip-month-list", { year });
        const monthData = response.data.data?.months || {};  // Correctly access 'months' key
        const formattedMonths = Object.entries(monthData).map(([key, value]) => ({
            id: key,
            name: value,
        }));
        setMonths(formattedMonths);
        setError(null);

        // Set default month if available
        if (response.data.data?.default_month) {
            const defaultMonthKey = Object.keys(monthData).find(
                key => monthData[key] === response.data.data.default_month
            );
            if (defaultMonthKey) {
                setSelectedMonth(defaultMonthKey);
            }
        } else if (formattedMonths.length > 0) {
            setSelectedMonth(formattedMonths[0].id);
        }
    } catch (err) {
        setError("Failed to fetch months. Please try again later.");
    }
};


  const handleDownloadReport = async () => {
    setLoading(true);

    try {
      const payload = {};
      if (selectedYear) payload.year = selectedYear;
      if (selectedMonth) payload.month = selectedMonth;

      const response = await api.post("/employer-report", payload);
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "text/csv" });
        const pad = (n) => String(n).padStart(2, "0");
        const d = new Date();
        const ts = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(
          d.getDate()
        )}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
        const fileName =
          selectedMonth && selectedYear
            ? `ESIC_PF_REPORT_${selectedYear}_${pad(selectedMonth)}_${ts}.csv`
            : `ESIC_PF_REPORT_${ts}.csv`;
        saveAs(blob, fileName);
        toast.success("Report downloaded successfully.");
      } else {
        toast.error("Failed to download the report.");
      }
    } catch (err) {
      toast.error("Error downloading the report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-4">
        <label htmlFor="yearSelect">Select Year</label>
        <select
          id="yearSelect"
          className="form-control"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          <option value="" disabled>
            Select Year
          </option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-4">
        <label htmlFor="monthSelect">Select Month</label>
        <select
          id="monthSelect"
          className="form-control"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          disabled={!selectedYear}
        >
          <option value="" disabled>
            Select Month
          </option>
          {months.map((month) => (
            <option key={month.id} value={month.id}>
              {month.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-4 d-flex align-items-end">
        <button
          onClick={handleDownloadReport}
          className="btn btn-primary w-100"
          disabled={!selectedYear || !selectedMonth || loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              &nbsp;Downloading...
            </>
          ) : (
            "Download Report"
          )}
        </button>
      </div>
    </div>
  );
};

export default EsicPfdataTable;
